exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-criteria-popup-container {\r\n    background-color: #F0F0F0;\r\n    padding-bottom: 15px;\r\n}\r\n.search-criteria-popup-container .delete-criteria-btn {\r\n    margin-left: 22px;\r\n    margin-top: -6px;\r\n    border: 0;\r\n    outline: 0;\r\n    font-size: 13px;\r\n    height: 35px;\r\n    width: 160px;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    background-color: #959595;\r\n}\r\n.search-criteria-popup-container .delete-criteria-btn:hover {\r\n    background-color: #CD202C;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-criteria-popup/search-criteria-popup.component.css
// module id = ../../../../../src/app/shared/lookup/search-criteria-popup/search-criteria-popup.component.css
// module chunks = main